var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8c60994c8803ab59c0579797cbd45a5a2d2c948b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["soraban-ys@soraban-ys"]={id:"8c60994c8803ab59c0579797cbd45a5a2d2c948b"};
      